export function validatePHONE(phone: string): boolean {
  phone = phone.replace(/[^\d]+/g, "");
  if (phone === "") return false;

  // Elimina phones invalidos conhecidos
  if (
    phone.length !== 11 ||
    phone === "00000000000" ||
    phone === "11111111111" ||
    phone === "22222222222" ||
    phone === "33333333333" ||
    phone === "44444444444" ||
    phone === "55555555555" ||
    phone === "66666666666" ||
    phone === "77777777777" ||
    phone === "88888888888" ||
    phone === "99999999999"
  ) {
    return false;
  }

  return true;
}
